import { PageIntro } from "@/components/PageIntro";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, MapPin } from "lucide-react";
import { api, inr } from "@/lib/api";

export const TYPE_LABEL = {
  luxury_tent: "Luxury tents", cottage: "Cottages", resort: "Resorts", heritage: "Heritage", homestay: "Homestays",
};

export function HotelCard({ h, testid }) {
  const from = Math.min(...h.room_types.map((r) => r.price_per_night));
  return (
    <Link to={`/stays/${h.slug}`} data-testid={testid} className="group bg-white ring-1 ring-black/5 rounded-2xl overflow-hidden">
      <div className="h-56 overflow-hidden relative">
        <img src={h.image_url} alt={h.name} className="w-full h-full object-cover group-hover:scale-105 transform duration-500"/>
        <span className="absolute top-3 left-3 bg-[#FAF7F2]/90 backdrop-blur px-3 py-1 rounded-full text-xs font-medium text-[#1E3A2B]">{TYPE_LABEL[h.property_type]}</span>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-serif text-xl text-[#1C2421]">{h.name}</h3>
          <span className="flex items-center gap-1 text-sm text-[#1E3A2B] shrink-0"><Star size={14} className="fill-[#D4A359] text-[#D4A359]"/>{h.rating}</span>
        </div>
        <p className="text-xs text-[#5C6B63] flex items-center gap-1 mt-1"><MapPin size={12}/>{h.location}</p>
        <p className="text-sm text-[#5C6B63] mt-2 mb-3 line-clamp-2">{h.short_description}</p>
        <div className="flex items-center justify-between">
          <span className="font-mono text-sm text-[#1E3A2B]">from {inr(from)} <span className="text-xs text-[#5C6B63]">/night</span></span>
          <span className="text-[#C86D51] text-sm">View rooms →</span>
        </div>
      </div>
    </Link>
  );
}

export default function Hotels() {
  const [hotels, setHotels] = useState([]);
  const [type, setType] = useState("all");
  useEffect(() => { api.get("/hotels").then((r) => setHotels(r.data)); }, []);
  const types = ["all", ...new Set(hotels.map((h) => h.property_type))];
  const shown = type === "all" ? hotels : hotels.filter((h) => h.property_type === type);

  return (
    <div className="jt-container py-16">
      <PageIntro page="stays"/>
      <div className="flex flex-wrap gap-2 mb-10">
        {types.map((t) => (
          <button key={t} onClick={() => setType(t)} data-testid={`stay-filter-${t}`}
            className={`px-4 py-2 rounded-full text-sm border ${type === t ? "bg-[#1E3A2B] text-white border-[#1E3A2B]" : "bg-white border-[#E2DACF]"}`}>
            {t === "all" ? "All stays" : TYPE_LABEL[t]}
          </button>
        ))}
      </div>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {shown.map((h) => <HotelCard key={h.id} h={h} testid={`stay-card-${h.slug}`}/>)}
      </div>
    </div>
  );
}
